export default "__VITE_ASSET___wLeM2X4__"